<template>
  <div id="g_id_onload"
    :data-client_id="clientId"
    data-callback="handleCredentialResponse"
    data-moment_callback="handlePromptChange"
    data-itp_support="true"
    :data-allowed_parent_origin="allowOrigin"
    data-use_fedcm_for_prompt="true"
    data-cancel_on_tap_outside="false">
  </div>
</template>

<script setup>
import { googleQuickLogin } from '@/api/user/user'
import gtagTools from '@/libs/gtag-tools'
import { useRoute } from 'vue-router'
import { postMessageToOpenerWindow, setToken } from '@/libs/utils'
import { postLoginResultToApp, reportLoginData, setLoginResultTmp } from '@/services/login'
import { ref } from 'vue'
import { appStore, userStore } from '@/stores'
import config from '@/config'

const loading = ref(false)

document.title = 'Google one tap'
const clientId = config.googleClientId
const allowOrigin = config.googleAllowOrigin

const $route = useRoute()

const { source, productName, shareKey, shareType } = $route.query
appStore.source = source || 'website'
appStore.productName = productName || 'UPDF'
userStore.shareKey = shareKey || ''
userStore.shareType = shareType || ''

// 添加谷歌sdk脚本
const script = document.createElement('script')
script.src = 'https://accounts.google.com/gsi/client'
script.async = true
script.defer = true
document.getElementsByTagName('head')[0].appendChild(script)

// 谷歌登录回调
window.handleCredentialResponse = async (response) => {
  gtagTools.googleOneTapClick()
  loading.value = true
  const token = response.credential
  // 通知父窗口显示loading
  postMessageToOpenerWindow('googleOneTapLoading', {})
  const { data } = await googleQuickLogin({ token })
  const loginType = 'google_one_tap'
  if (data.isNew) {
    gtagTools.signUp(loginType)
  } else {
    gtagTools.signIn(loginType)
  }
  // 储存登录信息，用于新用户注册后进入信息填写页后使用
  setLoginResultTmp(data)
  setToken(data.token, data.expiresAt)
  // 上报登录数据
  try {
    await reportLoginData(loginType)
  } catch (e) {
    console.log('上报数据失败', e)
  }
  postLoginResultToApp(loginType, data)
}

// 其他浏览器上时窗口发生变化时回调
window.handlePromptChange = (data) => {
  console.log(data)
}
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  right: 0;
  top: 0;
  width: 42px;
  height: 42px;
  background: #fff;
  border-radius: 50%;
  overflow: hidden;
}
</style>
